<!-- input -->
<form
  data-cy="bs-form"
  (submit)="handleSubmit()"
  (keydown.tab)="$event.stopPropagation()"
  (keydown.shift)="$event.stopPropagation()"
  (click)="$event.stopPropagation()">
  <div class="bs-field">
    <button mat-icon-button type="button" (click)="input.focus()">
      <mat-icon>search</mat-icon>
    </button>
    <input
      mat-input
      type="text"
      #input
      data-cy="borrower-search"
      class="bs-input tw-text-sm"
      placeholder="Business Search"
      [formControl]="searchControl"
      (keyup)="handleKeyup()">
    <button mat-icon-button type="button" *ngIf="!loading" [style.visibility]="searchControl.value ? 'visible' : 'hidden'" (click)="$event.preventDefault(); clearInput()">
      <mat-icon>close</mat-icon>
    </button>
    <div *ngIf="loading" class="tw-pr-2">
      <mat-spinner diameter="24"></mat-spinner>
    </div>
  </div>
</form>

<!-- results -->
<button mat-button [matMenuTriggerFor]="searchResultMenu" #resultTrigger class="menu-trigger">Menu</button>

<mat-menu #searchResultMenu="matMenu" class="bs-results">
  <button mat-menu-item *ngFor="let result of results" data-cy="bs-result" (click)="emitBorrower(result.borrower)">
    <span class="line">
      <span class="bold truncate" title="{{ result.borrower.name }}">{{ result.borrower.name }}</span>
      <span class="ml-1">{{ result.status }}</span>
    </span>
    <span class="line" *ngIf="result.matchedAttr">
      <span class="truncate">
        <span>{{ result.matchedAttr.label }}: </span>
        <span class="highlight" title="{{ result.matchedAttr.value }}">{{ result.matchedAttr.value }}</span>
      </span>
      <span></span>
    </span>
    <span class="line">
      <span class="truncate">Assigned: <span class="bold" title="{{ result.borrower.repFirst + ' ' + result.borrower.repLast }}">{{ result.borrower.repFirst + ' ' + result.borrower.repLast }}</span></span>
      <span></span>
    </span>
  </button>
  <div *ngIf="!results.length" (click)="clearInput()" class="bs-no-results">No results for "{{ searchControl.value }}".</div>
</mat-menu>
